import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';
import notification from '@tt/components/Notification';

// job Titles
function* fetchjobTitleSearchedData({ jobTitlesParams }) {
  try {
    yield put(Actions.setjobTitlesSearchedLoader({ jobTitlesSearchedLoader: true }));
    const { data } = yield call(api.get, {
      route: 'labourjobtitle/getsearched',
      params: jobTitlesParams,
    });
    const jobTitlesSearchedData = data;
    yield put(Actions.setjobTitlesSearched({ jobTitlesSearchedData }));
    yield put(Actions.setjobTitlesSearchedLoader({ jobTitlesSearchedLoader: false }));
  } catch (error) {
    yield put(Actions.setjobTitlesSearchedLoader({ jobTitlesSearchedLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* addUpdatejobTitles({ actionName, labourJobTitle, jobTitlesParams }) {
  try {
    yield put(Actions.setjobTitlesSearchedLoader({ jobTitlesSearchedLoader: true }));
    yield call(actionName === CONSTANT_VARIABLES.ADD ? api.post : api.put, {
      route: 'labourjobtitle',
      data: labourJobTitle,
    });
    yield put(Actions.fetchjobTitlesSearched({ jobTitlesParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.MASTER_JOB_TITLES_SUCCESS_ADD
        : CONSTANT_VARIABLES.MASTER_JOB_TITLES_SUCCESS_UPDATE,
      ''
    );
  } catch (error) {
    yield put(Actions.setjobTitlesSearchedLoader({ jobTitlesSearchedLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

function* deletejobTitles({ jobTitlesId, jobTitlesParams }) {
  try {
    yield put(Actions.setjobTitlesSearchedLoader({ jobTitlesSearchedLoader: true }));
    yield call(api.delete, {
      route: 'labourjobtitle/' + jobTitlesId,
    });
    yield put(Actions.fetchjobTitlesSearched({ jobTitlesParams }));
    notification('success', CONSTANT_VARIABLES.MASTER_JOB_TITLES_SUCCESS_DELETE, '');
  } catch (error) {
    yield put(Actions.setjobTitlesSearchedLoader({ jobTitlesSearchedLoader: false }));
    notification('error', error, '');
    console.warn(error); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_JOB_TITLES_SEARCHED, fetchjobTitleSearchedData),
    takeLatest(ActionTypes.ADD_UPDATE_JOB_TITLES, addUpdatejobTitles),
    takeLatest(ActionTypes.DELETE_JOB_TITLES, deletejobTitles),
  ]);
}
